import palette from '../palette';
import typography from '../typography';

export default {
  root: {
    ...typography.body2,
    borderBottom: '',
    padding: '12px 16px',
  },
  head: {
    padding: '10px 14px',
    color:  palette.white,
    fontWeight: 'medium',
    border: `0px`,
    borderBottom: `1px solid ${palette.border.main}`,
    background: palette.primary.main,
    fontSize: 16,
  },
  body: {
    padding: '8px 14px',
    color: palette.text.primary,
    fontWeight: 'medium',
    borderBottom: `1px solid ${palette.border.main}`,
  }
};
